import { render, staticRenderFns } from "./AppWelcomePanel.vue?vue&type=template&id=676636d0&scoped=true&"
import script from "./AppWelcomePanel.vue?vue&type=script&lang=js&"
export * from "./AppWelcomePanel.vue?vue&type=script&lang=js&"
import style0 from "./AppWelcomePanel.vue?vue&type=style&index=0&id=676636d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676636d0",
  null
  
)

export default component.exports